import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive, onMounted } from 'vue';
import { onBeforeRouteUpdate, useRoute } from 'vue-router';
import { asyncRoutes } from '@/router';
import { traversalMenus } from '@/utils/router';
import { useMenuStore } from '@/stores/menu';
import { useAppStore } from '@/stores/app';
import MenuTree from './MenuTree.vue';
export default {
  __name: 'MenuVertical',
  setup(__props) {
    const menus = traversalMenus(asyncRoutes);
    const route = useRoute();
    const app = useAppStore();
    const menu = useMenuStore();
    const state = reactive({
      defaultActive: '',
      defaultOpeneds: menus.map(m => m.path)
    });

    // 激活当前路由的菜单
    const currentRouteActive = currentRoute => {
      state.defaultActive = currentRoute.path;
    };
    onMounted(() => {
      menu.setMenus(menus);
      currentRouteActive(route);
    });
    onBeforeRouteUpdate(to => {
      currentRouteActive(to);
    });
    return (_ctx, _cache) => {
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createBlock(_component_el_scrollbar, {
        ref: "verticalMenusRef",
        class: "vertical-menus-scrollbar"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          class: "layouts-menu-vertical",
          "collapse-transition": false,
          "unique-opened": _unref(app).menuUniqueOpened,
          collapse: _unref(app).menuCollapse,
          "default-openeds": state.defaultOpeneds,
          "default-active": state.defaultActive
        }, {
          default: _withCtx(() => [_createVNode(MenuTree, {
            menus: _unref(menu).menus
          }, null, 8, ["menus"])]),
          _: 1
        }, 8, ["unique-opened", "collapse", "default-openeds", "default-active"])]),
        _: 1
      }, 512);
    };
  }
};